<template>
    <div class="my-1">
        <b-card>
            <div class="row">
                <div class="col-7">
                    <!-- <p class="card-text">
                    <b>{{ hotel.hotel }}</b><br>
                    <small>{{ hotel.pobla }}</small>
                    </p> -->
                    <div class="form-group">
                        <label class="text-small">Establecimientos</label>
                        <b-form-select v-model="hot"
                            :options="hoteles" value-field="id" text-field="name" class="mb-1" @change="change_combo"
                        ></b-form-select>
                        <!-- <p class="ml-2"><small>{{ pob }}</small></p> -->
                    </div>
                </div>
                <div class="col-5">
                    <div class="form-group">
                        <!-- <label class="text-small">Salidas / Transporte</label> -->
                        <b-form-select v-model="tip" :options="tipos" value-field="id" text-field="name" class="mb-0" @change="change_combo"/>
                        <b-form-select v-model="zon" :options="zonas" value-field="id" text-field="name" class="mb-0" @change="change_combo"/>
                    </div>
                </div>
            </div>

            <!-- tabla -->
            <b-table striped hover head-variant="light"
                :items="turnosFiltrados"
                :fields="turnos.fields"
                table-class="table-responsive bg-white"
                bordered
                height="300px"
                sticky-header
                responsive="sm">
                <!-- text-nowrap -->
                <!-- selectable select-mode="single" @row-selected="selecciona" @row-dblclicked="selecciona"> -->

                <template v-slot:table-colgroup>
                    <col style="width: 45%">
                    <col style="width: 20%">
                    <col style="width: 15%">
                    <col style="width: 8%">
                    <col style="width: 5%">
                    <col>
                </template>


                <template slot="cell(sal)" slot-scope="{item: { sal }}">
                    <small>{{ sal }}</small>
                </template>


                <template #cell(action)="data">

                    <!-- revisarrrrrrrrrrrrrrrrrr -->

                    <b-btn size="sm" variant="light" class="p-0"
                        v-if="(data.item.tp==2 && data.item.hab<=0) || (data.item.tp!=2 && data.item.pax<=0)">
                        <b-icon variant="danger" icon="x-square"></b-icon>
                    </b-btn>

                    <b-btn size="sm" variant="primary" class="p-1" v-else @click="selecciona(data.item)">
                        <b-icon class="p-0" icon="cart2"></b-icon>
                        <!-- <b-badge variant="success">{{(data.item.tp==2?data.item.hab:data.item.pax)}}</b-badge>                         -->
                        <!-- <b-badge variant="success">{{ data.item.lib }}</b-badge>                         -->
                    </b-btn>
                </template>

            </b-table>
        </b-card>
        <div class="row mx-1 pl-4 mt-1 bg- text-faded">
            <div class="col-3">Periodos <b>{{turnosFiltrados.length}}</b></div>
            <div class="col-5 pr-1 mt-1">
                <b-icon variant="success" icon="cart3"></b-icon> Reservar
                <b-icon variant="danger" icon="x-square" class="ml-4"></b-icon> Sin disponibilidad
                <!-- <br>A/H = Apartamentos ó Habitaciones Libres (Hotel)<br>Pax=Plazas (Personas) Libres -->
            </div>
            <p><small>* A/H = Apartamentos ó Habitaciones Libres (Hotel) <br>* Pax = Plazas (Personas) Libres</small></p>
            <!-- <p><small>* A/H = Apartamentos ó Habitaciones Libres (Hotel)<br>Pax = Plazas (Personas) Libres</small></p>             -->
        </div>
    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'hotelDispo',

    data() {
        return {
            plan: 1,

            hoteles: [],
            tipos: [],
            zonas: [],

            turnos: {
                items: {},
                fields: [
                    {key:'hotel',label:'Establecimiento'},
                    {key:'periodo',label:'Periodo'},
                    {key:'tph',label:'Tipo Hab.'},
                    {key:'hab',label:'A/H'},
                    {key:'pax',label:'Pax'},
                    {key:'action', label:''}

                ],
            },
            selected: {},

            //hotel: {},
            pob: '',
            hot: '0',
            zon: '0',
            tip: '0',
        }
    },

    mounted() {
        console.log('*mounted',this.hot,this.hotel,this.hoteles,this.turnos);
        //if (this.hot>'') return;
        //this.hot=(this.hotel.hot>0 ? this.hotel.hot : this.hoteles[0].hot);
        //this.hotel_precios(this.hot);

        this.plan=this.splan;

        this.leemos();
    },

    computed: {
        ...mapState(['auth']),

        logueado() {
            return this.auth.logueado;
        },

        splan() {
            return this.$store.state.plan;
        },

        shotel() {
            return this.$store.state.hotel;
        },

        turnosFiltrados() {
            // var H=this.$util.object_array(this.turnos.items);
            var H=this.turnos.items;
            if (this.hot>'0') {
                H = H.filter(item => item.hot.indexOf(this.hot) != -1);
            } else {
                if (this.zon>'0')
                    H = H.filter(item => item.zon.indexOf(this.zon) != -1);
                if (this.tip>'0')
                    H = H.filter(item => item.tpe.indexOf(this.tip) != -1);
            }

            //return this.$util.array_object(H);
            return H;
        },

        // salidas() { console.log('salidas',this.sal,this.turnos);
        //     // let result=this.$util.object_array(this.turnos.items);
        //     let result=this.turnos.items;

        //     var A=[{text:"Selecciona Transporte", value:'', disabled:false}];
        //     result.forEach(value => {
        //         let txt=(value.sal=='*SIN TRANSPORTE'?'* Sin Transporte':"BUS - "+value.sal);

        //         let names = A.map(e => e.value);
        //         //console.log(names.includes(value.sal)); // returns true
        //         if (!names.includes(value.sal))
        //             A.push({text:txt, value:value.sal, disabled:false});
        //     });

        //     return A;
        // },

    },
    methods: {
        ...mapMutations(['loading','alerta','modal']),
        ...mapActions(['exec']),

        async leemos() {
            this.loading();

            var args={ token: this.auth.token, plan: this.plan }
            let r=await this.exec({api:'vacantes_dispo', arg: args });

            this.loading(false);

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                //this.modal({tit:"RESERVAS", msg:r.datos});
                r.datos=[];
            }
            //guardamos datos
            this.turnos.items=Object.values(r.datos[0]);

            this.hoteles=Object.values(r.datos[1]);

            this.zonas=Object.values(r.datos[2]);
            this.tipos=Object.values(r.datos[3]);

            this.hot=this.zon=this.tip='0';

        },


        selecciona(item) {
            //this.$store.state.hotel=this.selected=(item.id==undefined ? item[0] : item);
            this.$store.state.hotel=this.selected=item;

            this.close();

            console.log('* hotel_dispo.selecciona',item,this.shotel);
        },

       /*  hotel_salidas() {
            // let result=this.$util.object_array(this.turnos.items);
            let result=this.turnos.items;

            var A=[{text:"Selecciona Transporte", value:'', disabled:false}];
            result.forEach(value => {
                let txt=(value.sal=='*SIN TRANSPORTE'?'* Sin Transporte':"BUS - "+value.sal);

                let names = A.map(e => e.value);
                //console.log(names.includes(value.sal)); // returns true
                if (!names.includes(value.sal))
                    A.push({text:txt, value:value.sal, disabled:false});
            });

            return A;
        }, */

        /* selecciona(item) {
            this.$store.state.hoteles.hotel=this.hotel;
            this.$store.state.hoteles.turno=item.item;
            // abrimos reservar sino ...
            if (this.$route.name!='reservar')
                this.$router.push('/reservar');
            console.log("*selecciona",item.item.id,this.$store.state.hoteles.turno);
            this.close();
        }, */

        change_combo(evt) {
            console.log("change_combo", evt);

            if (this.hot!='0') { this.zon=this.tip='0'; return; }
            if (this.zon!='0') { this.hot=this.tip='0'; return; }
            if (this.tip!='0') { this.hot=this.zon='0'; return; }

        },

        close() {
            this.$bvModal.hide('modal_hotelDispo');
        }
    }
}
</script>
